var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31404 13.0363C4.31349 13.0475 4.31321 13.0588 4.31321 13.07V13.2537C4.29555 14.1695 4.6066 15.061 5.1897 15.7696C5.20031 15.7825 5.21138 15.795 5.22289 15.8071C5.98414 16.6058 7.01043 17.1036 8.11156 17.2101C10.9144 17.5132 13.7423 17.5133 16.5452 17.2103C17.6488 17.1076 18.6777 16.6084 19.4371 15.805C19.4467 15.7949 19.4559 15.7845 19.4648 15.7738C20.0579 15.0648 20.3738 14.1667 20.3532 13.2443V13.07C20.3532 13.0598 20.353 13.0496 20.3525 13.0394C20.3218 12.3512 20.102 11.6849 19.7176 11.1122C19.6992 11.0847 19.6787 11.0585 19.6565 11.0339C19.2373 10.5708 18.9296 9.94882 18.791 9.32109C18.7764 9.08797 18.7791 8.85922 18.7822 8.60116L18.7824 8.5785C18.7857 8.30243 18.7887 7.99293 18.7603 7.66496L18.7603 7.66495L18.7597 7.6586C18.45 4.42971 15.3344 2.3125 12.3667 2.3125H12.2998C9.33272 2.3125 6.21508 4.42957 5.91491 7.66064L5.9149 7.66064L5.91453 7.66494C5.8682 8.19999 5.86935 8.69907 5.87049 9.19026C5.8706 9.24152 5.87072 9.2927 5.87079 9.34382C5.73192 9.96073 5.42685 10.5701 5.01251 11.0229C4.98813 11.0495 4.96589 11.078 4.94599 11.1082C4.5662 11.6833 4.34782 12.3488 4.31404 13.0363Z",
    stroke: "#717171",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4165C10.8804 20.9168 11.4391 21.2406 12.0523 21.3162C12.6656 21.3918 13.2828 21.213 13.7675 20.8194C13.9165 20.703 14.0506 20.5676 14.1667 20.4165",
    stroke: "#717171",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconGray);
export default __webpack_public_path__ + "static/media/Notification-Icon-Gray.6b0ea53d31b85f68aa20f32bc06ce068.svg";
export { ForwardRef as ReactComponent };